module.exports = __webpack_public_path__ + "static/img/led3mm.5f83a8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led3mm.svg
// module id = ZX/Z
// module chunks = 0